import { useTranslation } from "react-i18next";

export const useI18n = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng: "zh-CN" | "en-US") => {
    console.log("Changing language to:", lng);
    i18n.changeLanguage(lng);
  };

  const getCurrentLanguage = () => {
    return i18n.language;
  };

  const isChinese = () => {
    return i18n.language === "zh-CN";
  };

  const isEnglish = () => {
    return i18n.language === "en-US";
  };

  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    isChinese,
    isEnglish,
    currentLanguage: i18n.language,
    i18n, // 导出 i18n 实例用于调试
  };
};
